/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { useAuthContext } from '../contexts/AuthContext';
import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import { Fragment, useState } from 'react';
import EnvelopeWithBox from './../components/EnvelopeWithBox';
import Style from './../css/LoanHistory.module.css';
import { GNMAReportingProvider } from '../contexts/GNMAReportingContext';
import GNMAReportingForm from './../components/forms/GNMAReportingForm';

export default function LoanHistoryPage() {
  const { servicerUser } = useAuthContext();

  return (
    <Fragment>
      <EnvelopeWithBox blockName='GNMA Reporting'>
        <div className={Style.height}>
          <SnackbarProvider maxSnack={3} preventDuplicate anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <GNMAReportingProvider>
              <GNMAReportingForm />
            </GNMAReportingProvider>
          </SnackbarProvider>
        </div>
      </EnvelopeWithBox>
    </Fragment>
  );
}
